import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatElapsed, useCheckin } from "../lib/useCheckin.js";
import styles from "./CheckinBanner.module.css";

/** Sticky bar shown while the fisher is checked in, with a "done" button. */
export default function CheckinBanner() {
  const { t } = useTranslation();
  const { checkin, end } = useCheckin();
  const [now, setNow] = useState(() => Date.now());
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!checkin) return;
    const id = window.setInterval(() => setNow(Date.now()), 30000);
    return () => window.clearInterval(id);
  }, [checkin]);

  if (!checkin) return null;

  async function handleEnd() {
    setBusy(true);
    setError(false);
    try {
      await end();
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className={styles.bar} role="status">
      <span className={styles.text}>
        🎣 {t("checkin.active", { vald: checkin.valdName })} ·{" "}
        {formatElapsed(checkin.startedAt, now)}
        {error && <strong> — {t("checkin.endFailed")}</strong>}
      </span>
      <button
        type="button"
        className={styles.btn}
        onClick={handleEnd}
        disabled={busy}
      >
        {t("checkin.end")}
      </button>
    </div>
  );
}
